import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDLotteryTicket implements ICommand
{

	public BetTime : number = 0;
	public BetID : number = 0;
	public GameID : number = 0;
	public Remark : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.BetTime = ba.readInt53();
		this.BetID = ba.readInt53();
		this.GameID = ba.readInt53();
		this.Remark = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.BetTime);
		ba.writeUint53(this.BetID);
		ba.writeUint53(this.GameID);
		ba.writeString(this.Remark);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDLotteryTicket();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'BetTime(Q)='+this.BetTime+' ';
		str += 'BetID(Q)='+this.BetID+' ';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'Remark(S)='+this.Remark+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'LotteryTicket';
	}

}
